<template>
  <div class="page-container">
    <div class="head" v-if="!embedded">
      <div class="head-title">
        <img src="../../static/img/logo.png" class="head-logo" />
        景区旅游大数据中心
      </div>
      <div class="head-type">
        <div
          class="type-item"
          v-for="(item, index) in navItems"
          :key="index"
          :class="{ 'type-item2': index === activeNavIndex }"
          @click="typeChange(item)"
        >
          {{ item.label }}
          <div class="type-on" v-if="index === activeNavIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">&nbsp;&nbsp;</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img
            @click="refreshPage"
            src="../../static/img/refresh-ccw.png"
            style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            "
            v-if="isToday"
          />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime : '' }}
        </div>
      </div>
    </div>

    <div class="warning-main" :class="{ 'embedded-mode': embedded }">
      <div :id="mapId" class="migrateMap"></div>
      
      <div class="warning-left">
        <div class="data-box monitor-panel">
          <div class="monitor-title">
          <span class="title-text">监控操作</span>
          <button class="maintenance-btn-mini" :class="{ active: isMaintenancePanelOpen }" @click="toggleMaintenancePanel">
            <span class="mini-icon">⚙️</span>
            <span class="mini-badge" v-if="abnormalChannelCount > 0">{{ abnormalChannelCount }}</span>
          </button>
        </div>
          <!-- 监控点位统计 -->
          <div class="video-points-stats">
            <div class="stats-item">
              <span class="stats-icon online-icon"></span>
              <span class="stats-label">在线</span>
              <span class="stats-count">{{ onlineCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon offline-icon"></span>
              <span class="stats-label">离线</span>
              <span class="stats-count">{{ offlineCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon error-icon"></span>
              <span class="stats-label">异常</span>
              <span class="stats-count">{{ errorCount }}</span>
            </div>
            <div class="stats-item">
              <span class="stats-icon total-icon"></span>
              <span class="stats-label">总计</span>
              <span class="stats-count">{{ totalCount }}</span>
            </div>
          </div>
          
          <div class="filter-section">
            <div class="section-title">筛选展示</div>
            <div class="filter-row">
              <div class="filter-item">
                <span class="filter-label">区域筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterRegion">
                    <option value="">全部区域</option>
                    <option value="区域A">区域A</option>
                    <option value="区域B">区域B</option>
                    <option value="区域C">区域C</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              <div class="filter-item">
                <span class="filter-label">类型筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterType">
                    <option value="">全部类型</option>
                    <option value="入口">入口</option>
                    <option value="出口">出口</option>
                    <option value="道路">道路</option>
                    <option value="广场">广场</option>
                    <option value="停车场">停车场</option>
                    <option value="设施">设施</option>
                    <option value="景点">景点</option>
                    <option value="商业">商业</option>
                    <option value="游乐设施">游乐设施</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
              <div class="filter-item">
                <span class="filter-label">状态筛选</span>
                <div class="filter-select-box">
                  <select class="filter-select" v-model="filterStatus">
                    <option value="">全部状态</option>
                    <option value="online">在线</option>
                    <option value="offline">离线</option>
                    <option value="error">异常</option>
                  </select>
                  <span class="select-arrow">▼</span>
                </div>
              </div>
            </div>
          </div>

          <div class="screen-section">
            <div class="section-title">多屏切换</div>
            <div class="screen-buttons">
              <button class="screen-btn" :class="{ active: currentScreenCount === 1 }" @click="changeScreenCount(1)">1 屏</button>
              <button class="screen-btn" :class="{ active: currentScreenCount === 4 }" @click="changeScreenCount(4)">4 屏</button>
              <button class="screen-btn" :class="{ active: currentScreenCount === 9 }" @click="changeScreenCount(9)">9 屏</button>
              <button class="screen-btn" :class="{ active: currentScreenCount === 16 }" @click="changeScreenCount(16)">16 屏</button>
              <button class="screen-btn" :class="{ active: currentScreenCount === 64 }" @click="changeScreenCount(64)">64 屏</button>
            </div>
          </div>

          <div class="timeline-section">
            <div class="section-title">事件回溯</div>
            <div class="timeline-list">
              <div 
                class="timeline-item" 
                v-for="(item, index) in timelineData" 
                :key="index"
                @click="openVideoPlayback(item)"
              >
                <span class="timeline-time">{{ item.time }}</span>
                <span class="timeline-dot" :class="'dot-' + (item.type || 'normal')"></span>
                <span class="timeline-content">{{ item.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 视频回放弹窗 -->
      <div class="video-playback-modal" v-if="isPlaybackModalOpen">
        <div class="modal-overlay" @click="closePlaybackModal"></div>
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">事件回放</div>
            <button class="modal-close" @click="closePlaybackModal">
              <span>×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="playback-info">
              <div class="info-row">
                <span class="info-label">事件类型：</span>
                <span class="info-value" :class="'type-' + currentEvent.type">{{ currentEvent.content }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">事件时间：</span>
                <span class="info-value">{{ currentEvent.time }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">回放时段：</span>
                <span class="info-value">{{ currentEvent.startTime }} - {{ currentEvent.endTime }}</span>
              </div>
            </div>
            <div class="video-container">
              <video 
                ref="playbackVideo"
                :src="playbackVideoUrl"
                class="playback-video" 
                controls 
                autoplay 
                muted 
                playsinline
              ></video>
            </div>
            <div class="export-section">
              <div class="export-title">片段导出</div>
              <div class="time-range-selector">
                <div class="range-item">
                  <span class="range-label">开始时间：</span>
                  <input type="datetime-local" class="time-input" v-model="exportStartTime" />
                </div>
                <div class="range-item">
                  <span class="range-label">结束时间：</span>
                  <input type="datetime-local" class="time-input" v-model="exportEndTime" />
                </div>
                <button class="export-btn" @click="exportVideo">导出片段</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 点位视频播放弹窗 -->
      <div class="point-video-modal" v-if="isPointVideoModalOpen">
        <div class="modal-overlay" @click="closePointVideoModal"></div>
        <div class="modal-content video-modal">
          <div class="modal-header">
            <div class="modal-title">
              <span class="modal-icon">📹</span>
              <span>{{ currentPlayPoint && currentPlayPoint.name || '监控视频' }}</span>
            </div>
            <button class="modal-close" @click="closePointVideoModal">
              <span>×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- 在线状态显示视频播放器 -->
            <div class="video-container" v-if="currentPlayPoint && currentPlayPoint.status === 'online'">
              <video
                ref="pointVideoPlayer"
                class="point-video-player"
                autoplay
                controls
                playsinline
                width="100%"
                height="100%"
              >
                <source :src="currentPlayPoint && currentPlayPoint.url" type="video/flv" />
                <source :src="currentPlayPoint && currentPlayPoint.url" type="video/mp4" />
              </video>
            </div>
            <!-- 离线或异常状态显示提示信息 -->
            <div class="video-container offline-container" v-else>
              <div class="offline-message">
                <span class="offline-icon">⚠️</span>
                <span class="offline-text">{{ currentPlayPoint && currentPlayPoint.statusText || '监控异常' }}</span>
              </div>
            </div>
            <div class="video-info">
              <div class="info-row">
                <span class="info-label">区域：</span>
                <span class="info-value">{{ currentPlayPoint && currentPlayPoint.region || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">类型：</span>
                <span class="info-value">{{ currentPlayPoint && currentPlayPoint.type || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">状态：</span>
                <span class="info-value" :class="(currentPlayPoint && currentPlayPoint.status === 'online') ? 'status-online' : 'status-offline'">
                  {{ currentPlayPoint && currentPlayPoint.statusText || '未知' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 运维看板面板 -->
      <div class="maintenance-panel" :class="{ 'show': isMaintenancePanelOpen }">
        <div class="data-box maintenance-content">
          <div class="maintenance-header">
            <div class="maintenance-title">数据传输通道状态</div>
            <button class="maintenance-close" @click="toggleMaintenancePanel">
              <span>×</span>
            </button>
          </div>
          <div class="channel-list">
            <div 
              class="channel-item" 
              v-for="channel in channelStatusList" 
              :key="channel.id"
              :class="getChannelStatusClass(channel.status)"
            >
              <div class="channel-status-dot"></div>
              <div class="channel-info">
                <div class="channel-name">{{ channel.name }}</div>
                <div class="channel-device">设备：{{ channel.device }}</div>
              </div>
              <div class="channel-status">
                <span :class="getChannelStatusClass(channel.status)">{{ getChannelStatusText(channel.status) }}</span>
              </div>
              <div class="channel-time">
                <span class="time-label">最后上报：</span>
                <span class="time-value">{{ channel.lastReportTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="warning-right" :class="{ 'collapsed': !isPanelExpanded }">
        <div class="data-box screen-preview-panel">
          <!-- 可点击的标题栏，用于展开/隐藏 -->
          <div 
            class="monitor-toggle-header" 
            @click="togglePanel"
          >
            <div class="monitor-title">实时监控</div>
            <div class="toggle-icon">{{ isPanelExpanded ? '◀' : '▶' }}</div>
          </div>
          
          <!-- 监控内容区域 -->
          <div class="monitor-content" :class="{ 'show': isPanelExpanded }">
            <div 
                class="screen-grid"
                :style="getGridStyle()"
              >
                <div 
                  class="screen-grid-item" 
                  v-for="(n, index) in screenGridCount" 
                  :key="index"
                  :style="getGridItemStyle()"
                  :class="{ 'dragging': dragIndex === index, 'drag-over': dragOverIndex === index }"
                  @mousedown="startDrag($event, index)"
                  @mouseenter="onDragEnter(index)"
                  @mouseup="endDrag"
                  @mouseleave="onDragLeave"
                >
                  <div class="screen-video-wrapper">
                    <div class="screen-video-body">
                      <video 
                        :ref="'screenVideo' + index"
                        :src="getVideoUrl(index)"
                        class="screen-video" 
                        autoplay 
                        muted 
                        playsinline
                        loop
                      ></video>
                    </div>
                  </div>
                </div>
              </div>
            <div class="screen-info">当前选择：{{ currentScreenCount }}屏</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { getSettingByIdApi } from '../api/ScenicAPI'

const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}

const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navItems: [
        { label: '文旅市场', path: '/', query: { typeIndex: 0 } },
        { label: '客流分析', path: '/scenic_date_data', query: { typeIndex: 0 } },
        { label: '大数据驾驶舱', path: '/', query: { typeIndex: 2 } },
        { label: '客流预警', path: '/scenic_warning', query: {} }
      ],
      activeNavIndex: 3,
      scenic_id: '',
      req_date: null,
      isToday: true,
      nowDay: '',
      nowDay2: '',
      nowTime: '',
      week: '',
      changeWeek: '',
      hour: '',
      weather: {},
      warningRecordCount: 10,
      recordVisible: true,
      timelineData: [
        { time: '06-05 11:22:33', content: '客流拥堵', type: 'congestion', videoUrl: '', startTime: '2026-06-05 11:20:00', endTime: '2026-06-05 11:30:00' },
        { time: '06-05 14:15:22', content: '设备故障', type: 'fault', videoUrl: '', startTime: '2026-06-05 14:10:00', endTime: '2026-06-05 14:20:00' },
        { time: '06-05 15:45:10', content: '客流拥堵', type: 'congestion', videoUrl: '', startTime: '2026-06-05 15:40:00', endTime: '2026-06-05 15:50:00' },
        { time: '06-05 16:30:45', content: '设备故障', type: 'fault', videoUrl: '', startTime: '2026-06-05 16:25:00', endTime: '2026-06-05 16:35:00' },
        { time: '06-05 18:20:15', content: '客流拥堵', type: 'congestion', videoUrl: '', startTime: '2026-06-05 18:15:00', endTime: '2026-06-05 18:25:00' },
        { time: '06-05 19:05:33', content: '客流拥堵', type: 'congestion', videoUrl: '', startTime: '2026-06-05 19:00:00', endTime: '2026-06-05 19:10:00' },
        { time: '06-05 20:30:00', content: '设备故障', type: 'fault', videoUrl: '', startTime: '2026-06-05 20:25:00', endTime: '2026-06-05 20:35:00' },
        { time: '06-05 21:15:40', content: '客流拥堵', type: 'congestion', videoUrl: '', startTime: '2026-06-05 21:10:00', endTime: '2026-06-05 21:20:00' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' },
        { time: '06-05 11:22:33', content: '客流拥堵' }
      ],

      mapId: 'sentimentMap',
      setting: {
        map_show: 5,
        lat_offset: 0,
        lng_offset: 0
      },
      map: null,
      currentScreenCount: 1,
      isPanelExpanded: true, // 控制实时监控面板的展开/隐藏状态
      dragIndex: -1, // 当前拖拽的索引
      dragOverIndex: -1, // 当前拖拽经过的索引
      isMaintenancePanelOpen: false, // 运维看板面板是否打开
      isPlaybackModalOpen: false, // 视频回放弹窗是否打开
      filterRegion: '', // 区域筛选
      filterType: '', // 类型筛选
      filterStatus: '', // 状态筛选
      isPointVideoModalOpen: false, // 点位视频播放弹窗是否打开
      currentEvent: {}, // 当前选中的事件
      playbackVideoUrl: '', // 回放视频地址
      exportStartTime: '', // 导出开始时间
      exportEndTime: '', // 导出结束时间
      channelStatusList: [ // 数据传输通道状态列表
        { id: 1, name: '通道A-主链路', status: 'normal', lastReportTime: '2026-06-05 14:30:25', device: '设备001' },
        { id: 2, name: '通道A-备用链路', status: 'normal', lastReportTime: '2026-06-05 14:30:22', device: '设备002' },
        { id: 3, name: '通道B-主链路', status: 'abnormal', lastReportTime: '2026-06-05 13:45:18', device: '设备003' },
        { id: 4, name: '通道B-备用链路', status: 'normal', lastReportTime: '2026-06-05 14:29:58', device: '设备004' },
        { id: 5, name: '通道C-主链路', status: 'offline', lastReportTime: '2026-06-05 10:22:11', device: '设备005' },
        { id: 6, name: '通道C-备用链路', status: 'normal', lastReportTime: '2026-06-05 14:30:15', device: '设备006' },
        { id: 7, name: '通道D-主链路', status: 'normal', lastReportTime: '2026-06-05 14:30:28', device: '设备007' },
        { id: 8, name: '通道D-备用链路', status: 'abnormal', lastReportTime: '2026-06-05 12:15:44', device: '设备008' }
      ],
      boundaryLayer: null,
      boundaryGeometries: [],
      boundaryBounds: null,
      viewportBounds: null,
      markerLayer: null,
      videoPoints: [],
      statusIcons: {
        online: null,
        offline: null,
        error: null
      },
      // 当前播放的点位
      currentPlayPoint: null,
      // FLV播放器实例
      videoPlayers: [],
      
      clockTimer: null,
      flvUrl: [
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000015.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000014.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000013.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000012.flv',  
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000011.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/00000000010.flv',
        'https://hunou-vod.q12301.com/video/0402b05801a097f7/0000000009.flv'
      ]
    }
  },
  mounted() {
    console.log('video-surveillance mounted')
    if (!this.$route.query.id) {
      const id = sessionStorage.getItem('scenicId')
      this.$router.push({ path: '/scenic_warning', query: { id: id, token: store.state.token } })
      this.$router.go(0)
      return
    }

    this.scenic_id = this.$route.query.id
    this.getToday()

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date) {
        const reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }
    }

    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token)
    }

    this.isToday = !(this.req_date && this.req_date !== '' && this.req_date !== this.nowDay2)
    this.startClock()
    
    // 初始化状态图标
    this.statusIcons = {
      online: require('../../static/img/iconfont/success.png'),
      offline: require('../../static/img/iconfont/no.png'),
      error: require('../../static/img/iconfont/error.png')
    }
    
    this.$nextTick(() => {
      setTimeout(() => {
        this.renderWuyuanHeatMap()
      }, 300)
      
      // 初始化视频播放器
      setTimeout(() => {
        this.initVideoPlayers()
      }, 500)
    })
  },
  computed: {
    screenGridCount() {
      return Array.from({ length: this.currentScreenCount }, (_, i) => i + 1)
    },
    abnormalChannelCount() {
      return this.channelStatusList.filter(channel => channel.status === 'abnormal' || channel.status === 'offline').length
    },
    // 统计各状态点位数量
    onlineCount() {
      return this.videoPoints.filter(point => point.status === 'online').length
    },
    offlineCount() {
      return this.videoPoints.filter(point => point.status === 'offline').length
    },
    errorCount() {
      return this.videoPoints.filter(point => point.status === 'error').length
    },
    totalCount() {
      return this.videoPoints.length
    },
    // 根据屏数动态计算右侧面板宽度（自适应，最大90vh由CSS控制）
    rightPanelWidth() {
      // 返回auto，让元素根据内容自动调整宽度
      // 最大宽度由CSS的max-width: 90vh控制
      return 'auto'
    },
    // 根据屏数动态计算右侧面板高度（自适应，最大90vh由CSS控制）
    rightPanelHeight() {
      // 返回auto，让元素根据内容自动调整高度
      // 最大高度由CSS的max-height: 90vh控制
      return 'auto'
    }
  },
  beforeDestroy() {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
    if (this.boundaryLayer && this.boundaryLayer.setMap) {
      this.boundaryLayer.setMap(null)
      this.boundaryLayer = null
    }
    if (this.markerLayer && this.markerLayer.setMap) {
      this.markerLayer.setMap(null)
      this.markerLayer = null
    }
    if (this.textLayer && this.textLayer.setMap) {
      this.textLayer.setMap(null)
      this.textLayer = null
    }
    if (this.map && this.map.destroy) {
      this.map.destroy()
      this.map = null
    }
    // 销毁视频播放器
    this.destroyVideoPlayers()
  },
  watch: {
    filterRegion() {
      this.applyFilter()
    },
    filterType() {
      this.applyFilter()
    },
    filterStatus() {
      this.applyFilter()
    }
  },
  methods: {
    // 获取视频名称
    getVideoName(index) {
      const onlinePoints = this.getFilteredPoints().filter(p => p.status === 'online')
      if (index < onlinePoints.length) {
        return onlinePoints[index].name
      }
      return `监控${index + 1}`
    },
    // 获取视频流地址
    getVideoUrl(index) {
      // 所有情况下都使用本地静态视频
      // 1-16 屏按顺序播放，超过 16 屏的随机播放
      let videoNumber
      if (index < 16) {
        videoNumber = index + 1
      } else {
        videoNumber = Math.floor(Math.random() * 16) + 1
      }
      return `/static/mp4/${videoNumber}.mp4`
    },
    // 获取筛选后的点位
    getFilteredPoints() {
      return this.videoPoints.filter(point => {
        if (this.filterRegion && point.region !== this.filterRegion) {
          return false
        }
        if (this.filterType && point.type !== this.filterType) {
          return false
        }
        if (this.filterStatus && point.status !== this.filterStatus) {
          return false
        }
        return true
      })
    },
    // 应用筛选并更新地图
    applyFilter() {
      const filteredPoints = this.getFilteredPoints()
      this.updateMapMarkers(filteredPoints)
    },
    // 更新地图标记
    updateMapMarkers(points) {
      if (!this.markerLayer || !this.labelLayer) return

      const markerGeometries = points.map(point => ({
        id: point.id.toString(),
        position: new TMap.LatLng(point.lat, point.lng),
        styleId: point.status,
        properties: {
          name: point.name,
          status: point.status,
          url: point.url,
          region: point.region,
          type: point.type
        }
      }))

      const labelGeometries = points.map(point => ({
        id: 'label_' + point.id.toString(),
        position: new TMap.LatLng(point.lat, point.lng),
        content: point.name,
        styleId: 'label'
      }))

      this.markerLayer.setGeometries(markerGeometries)
      this.labelLayer.setGeometries(labelGeometries)
    },
    // 创建FLV播放器
    createFlvPlayer(videoElement, url, options) {
      if (!videoElement || typeof flvjs === 'undefined') {
        console.error('FLV player creation failed: flvjs not available or video element is null')
        return null
      }
      if (!flvjs.isSupported()) {
        console.error('FLV player creation failed: flvjs is not supported in this browser')
        return null
      }
      var playerOptions = options || {}
      if (playerOptions.muted) {
        videoElement.muted = true
      }
      var player = flvjs.createPlayer({
        type: 'flv',
        url: url,
        isLive: true,
        hasAudio: false,
        hasVideo: true,
        enableStashBuffer: false,
        stashInitialSize: 128,
        lazyLoad: false,
        lazyLoadMaxDuration: 0,
        seekType: 'range',
        cors: true
      })
      
      // 添加事件监听
      player.on(flvjs.Events.ERROR, (err) => {
        console.error(`FLV player error for ${url}:`, err)
      })
      player.on(flvjs.Events.LOADING_COMPLETE, () => {
        console.log(`FLV player loading complete for ${url}`)
      })
      player.on(flvjs.Events.METADATA_ARRIVED, () => {
        console.log(`FLV player metadata arrived for ${url}`)
      })
      player.on(flvjs.Events.BUFFER_FULL, () => {
        console.log(`FLV player buffer full for ${url}`)
      })
      
      player.attachMediaElement(videoElement)
      player.load()
      var playPromise = player.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch((err) => {
          console.error(`FLV player play failed for ${url}:`, err)
        })
      }
      return player
    },
    // 初始化视频播放器
    initVideoPlayers() {
      this.destroyVideoPlayers()
      
      console.log('Initializing video players...')
      console.log('Current screen count:', this.currentScreenCount)
      
      // 所有情况下都直接使用 video 标签的 src 属性播放本地静态视频
      console.log('Using native video src for all screen modes')
      return
    },
    // 销毁视频播放器
    destroyVideoPlayers() {
      if (!this.videoPlayers.length) {
        return
      }
      this.videoPlayers.forEach(item => {
        const videoElement = this.$refs[item.refName]
        try {
          if (item.player) {
            item.player.pause()
            item.player.unload()
            item.player.detachMediaElement()
            item.player.destroy()
          }
        } catch (error) {
          console.error('Failed to destroy player:', error)
        }
        if (videoElement) {
          try {
            videoElement.pause()
            videoElement.removeAttribute('src')
            videoElement.load()
          } catch (error) {
            console.error('Failed to reset video element:', error)
          }
        }
      })
      this.videoPlayers = []
    },
    // 根据屏数计算网格样式
    getGridStyle() {
      const screenCount = this.currentScreenCount
      let columns = 1
      let gap = 8
      let minWidth = 120
      
      // 根据屏数确定列数和最小宽度
      if (screenCount === 1) {
        columns = 1
        minWidth = 300
      } else if (screenCount === 4) {
        columns = 2
        minWidth = 140
      } else if (screenCount === 9) {
        columns = 3
        minWidth = 100
      } else if (screenCount === 16) {
        columns = 4
        minWidth = 80
      } else if (screenCount === 64) {
        columns = 8
        minWidth = 50
        gap = 4
      }
      
      return {
        gridTemplateColumns: `repeat(${columns}, minmax(${minWidth}px, 1fr))`,
        gap: `${gap}px`
      }
    },
    // 切换运维看板面板的展开/隐藏状态
    toggleMaintenancePanel() {
      this.isMaintenancePanelOpen = !this.isMaintenancePanelOpen
    },
    // 打开视频回放弹窗
    openVideoPlayback(event) {
      this.currentEvent = event
      this.isPlaybackModalOpen = true
      
      // 根据事件类型选择视频
      let videoNumber
      if (event.content === '客流拥堵') {
        // 客流拥堵默认使用第 10 个视频
        videoNumber = 10
      } else {
        // 其他事件随机选择一个本地视频（1.mp4 到 16.mp4）
        videoNumber = Math.floor(Math.random() * 16) + 1
      }
      this.playbackVideoUrl = `/static/mp4/${videoNumber}.mp4`
      
      // 设置默认导出时间范围
      if (event.startTime && event.endTime) {
        this.exportStartTime = event.startTime.replace(' ', 'T')
        this.exportEndTime = event.endTime.replace(' ', 'T')
      }
    },
    // 关闭视频回放弹窗
    closePlaybackModal() {
      this.isPlaybackModalOpen = false
      this.currentEvent = {}
    },
    // 关闭点位视频播放弹窗
    closePointVideoModal() {
      this.isPointVideoModalOpen = false
    },
    // 导出视频片段
    exportVideo() {
      if (!this.playbackVideoUrl) {
        console.log('没有可导出的视频')
        return
      }
      
      // 创建隐藏的下载链接
      const link = document.createElement('a')
      link.href = this.playbackVideoUrl
      link.download = `视频片段_${new Date().getTime()}.mp4`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      console.log(`正在下载视频：${this.playbackVideoUrl}`)
    },
    // 获取通道状态样式
    getChannelStatusClass(status) {
      switch (status) {
        case 'normal':
          return 'status-normal'
        case 'abnormal':
          return 'status-abnormal'
        case 'offline':
          return 'status-offline'
        default:
          return 'status-normal'
      }
    },
    // 获取通道状态文字
    getChannelStatusText(status) {
      switch (status) {
        case 'normal':
          return '正常'
        case 'abnormal':
          return '异常'
        case 'offline':
          return '离线'
        default:
          return '未知'
      }
    },
    // 切换实时监控面板的展开/隐藏状态
    togglePanel() {
      console.log('togglePanel called, current state:', this.isPanelExpanded)
      this.isPanelExpanded = !this.isPanelExpanded
      console.log('togglePanel new state:', this.isPanelExpanded)
      // 如果展开，重新初始化视频播放器
      if (this.isPanelExpanded) {
        this.$nextTick(() => {
          this.initVideoPlayers()
        })
      }
    },
    // 开始拖拽
    startDrag(event, index) {
      if (this.currentScreenCount <= 1) return
      this.dragIndex = index
      event.preventDefault()
      document.addEventListener('mouseup', this.globalEndDrag)
    },
    // 拖拽经过
    onDragEnter(index) {
      if (this.dragIndex !== -1 && this.dragIndex !== index) {
        this.dragOverIndex = index
      }
    },
    // 拖拽离开
    onDragLeave() {
      this.dragOverIndex = -1
    },
    // 结束拖拽
    endDrag() {
      if (this.dragIndex !== -1 && this.dragOverIndex !== -1) {
        this.swapVideoStreams(this.dragIndex, this.dragOverIndex)
      }
      this.dragIndex = -1
      this.dragOverIndex = -1
    },
    // 全局结束拖拽
    globalEndDrag() {
      this.endDrag()
      document.removeEventListener('mouseup', this.globalEndDrag)
    },
    // 交换两个视频流的位置
    swapVideoStreams(fromIndex, toIndex) {
      const onlinePoints = this.videoPoints.filter(p => p.status === 'online')
      if (fromIndex < onlinePoints.length && toIndex < onlinePoints.length) {
        const fromPoint = onlinePoints[fromIndex]
        const toPoint = onlinePoints[toIndex]
        const fromIndexInAll = this.videoPoints.findIndex(p => p.id === fromPoint.id)
        const toIndexInAll = this.videoPoints.findIndex(p => p.id === toPoint.id)
        // 交换位置
        const temp = this.videoPoints[fromIndexInAll]
        this.videoPoints[fromIndexInAll] = this.videoPoints[toIndexInAll]
        this.videoPoints[toIndexInAll] = temp
      }
      // 重新初始化播放器
      this.$nextTick(() => {
        this.destroyVideoPlayers()
        this.initVideoPlayers()
      })
    },
    // 获取网格项样式（根据屏数计算最合适的展示尺寸）
    getGridItemStyle() {
      const screenCount = this.currentScreenCount
      
      // 外层容器最大为 90vh
      const maxContainerSize = 90
      
      // 减去标题、底部信息、边距等高度（约 5vh）
      const availableSize = maxContainerSize - 8
      
      // 根据屏数计算网格行列数
      let cols, rows
      switch (screenCount) {
        case 1:
          cols = 1
          rows = 1
          break
        case 4:
          cols = 2
          rows = 2
          break
        case 9:
          cols = 3
          rows = 3
          break
        case 16:
          cols = 4
          rows = 4
          break
        case 64:
          cols = 8
          rows = 8
          break
        default:
          cols = 1
          rows = 1
      }
      
      // 计算每个网格项的基础尺寸（考虑 16:9 宽高比）
      // 高度 = availableSize / rows
      // 宽度 = 高度 * (16/9)
      let itemHeight = (availableSize / rows) * 0.95 // 留出 5% 的间距
      
      // 一屏时使用更小的尺寸
      if (screenCount === 1) {
        itemHeight = itemHeight * 0.6 // 缩小到 60%
      }
      
      const itemWidth = itemHeight * (16 / 9)
      
      // 取宽度和高度中的较小值作为最终尺寸（保持正方形，确保不超出容器）
      const finalSize = Math.min(itemWidth, itemHeight)
      
      return {
        width: `${finalSize}vh`,
        height: `${finalSize * (9 / 16)}vh` // 保持 16:9 比例
      }
    },
    changeScreenCount(count) {
      // 重置拖拽状态
      this.dragIndex = -1
      this.dragOverIndex = -1
      document.removeEventListener('mouseup', this.globalEndDrag)
      
      this.currentScreenCount = count
      this.$nextTick(() => {
        this.initVideoPlayers()
      })
    },
    getToday() {
      const today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      let date = today.getDate()
      let day = today.getDay()
      let hour = today.getHours()
      let minute = today.getMinutes()
      let second = today.getSeconds()

      month = this.doHandleMonth(month)
      date = this.doHandleDate(date)
      hour = this.doHandleHour(hour)
      minute = this.doHandleMinute(minute)
      second = this.doHandleSecond(second)

      this.nowDay = year + '-' + month + '-' + date
      this.nowDay2 = year + '-' + month + '-' + date
      this.nowTime = hour + ':' + minute + ':' + second
      this.week = this.getWeek(day)
    },
    doHandleMonth(month) {
      if (month < 10) {
        return '0' + month
      }
      return month
    },
    doHandleDate(date) {
      if (date < 10) {
        return '0' + date
      }
      return date
    },
    doHandleHour(hour) {
      if (hour < 10) {
        return '0' + hour
      }
      return hour
    },
    doHandleMinute(minute) {
      if (minute < 10) {
        return '0' + minute
      }
      return minute
    },
    doHandleSecond(second) {
      if (second < 10) {
        return '0' + second
      }
      return second
    },
    getWeek(day) {
      const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return weekArr[day]
    },
    startClock() {
      this.clockTimer = setInterval(() => {
        const today = new Date()
        let hour = today.getHours()
        let minute = today.getMinutes()
        let second = today.getSeconds()

        hour = this.doHandleHour(hour)
        minute = this.doHandleMinute(minute)
        second = this.doHandleSecond(second)

        this.nowTime = hour + ':' + minute + ':' + second
      }, 1000)
    },
    getSettingById() {
      return getSettingByIdApi({
        scenic_id: this.scenic_id
      }).then(res => {
        if (res.data && res.data.data) {
          this.setting = Object.assign({}, this.setting, res.data.data)
        }
      }).catch(() => {
        return Promise.resolve()
      })
    },
    fetchBoundaryData() {
      const fetchWithFallback = (urls, index = 0) => {
        if (index >= urls.length) {
          return Promise.reject(new Error('All boundary data sources failed'))
        }
        return fetch(urls[index])
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch ${urls[index]}`)
            }
            return response.json()
          })
          .catch(() => fetchWithFallback(urls, index + 1))
      }
      return fetchWithFallback(WUYUAN_BOUNDARY_URLS)
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries || this.boundaryGeometries.length === 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity, maxLat = -Infinity
      let minLng = Infinity, maxLng = -Infinity

      try {
        this.boundaryGeometries.forEach(geo => {
          if (!geo || !geo.coordinates || geo.coordinates.length === 0) {
            return
          }
          const coordinates = geo.coordinates[0]
          if (!coordinates || !Array.isArray(coordinates)) {
            return
          }
          coordinates.forEach(point => {
            if (!point || point.length < 2) {
              return
            }
            const lng = point[0]
            const lat = point[1]
            if (isNaN(lng) || isNaN(lat)) {
              return
            }
            minLng = Math.min(minLng, lng)
            maxLng = Math.max(maxLng, lng)
            minLat = Math.min(minLat, lat)
            maxLat = Math.max(maxLat, lat)
          })
        })
      } catch (error) {
        console.error('Error calculating boundary bounds:', error)
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      if (minLat === Infinity || maxLat === -Infinity || minLng === Infinity || maxLng === -Infinity) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      const paddingX = (maxLng - minLng) * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      const paddingY = (maxLat - minLat) * WUYUAN_VIEW_VERTICAL_PADDING_RATIO

      if (paddingX <= 0 || paddingY <= 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: { lat: minLat - paddingY, lng: minLng - paddingX },
        ne: { lat: maxLat + paddingY, lng: maxLng + paddingX }
      }

      const centerLat = (minLat + maxLat) / 2
      const centerLng = (minLng + maxLng) / 2
      const viewportWidth = (maxLng - minLng) * (1 + WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO * 2)
      const viewportHeight = (maxLat - minLat) * (1 + WUYUAN_VIEW_VERTICAL_PADDING_RATIO * 2)

      this.viewportBounds = {
        sw: { lat: centerLat - viewportHeight / 2, lng: centerLng - viewportWidth / 2 },
        ne: { lat: centerLat + viewportHeight / 2, lng: centerLng + viewportWidth / 2 }
      }
      return this.boundaryBounds
    },
    renderBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(24, 50, 112, 0.10)',
        showBorder: true,
        borderColor: 'rgba(120, 238, 255, 0.95)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanHeatMap(retryCount = 0) {
      const maxRetries = 20
      const mapContainer = document.getElementById(this.mapId)
      
      if (!mapContainer) {
        console.log('Map container not found with id:', this.mapId)
        if (retryCount < maxRetries) {
          requestAnimationFrame(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          })
        }
        return
      }

      const rect = mapContainer.getBoundingClientRect()
      console.log('Map container rect (attempt', retryCount + 1, '):', rect)
      
      if (rect.width <= 0 || rect.height <= 0) {
        console.log('Map container size is invalid (width:', rect.width, ', height:', rect.height, '), retrying...')
        
        const parent = mapContainer.parentElement
        if (parent) {
          const parentRect = parent.getBoundingClientRect()
          console.log('Parent container rect:', parentRect)
          
          const grandParent = parent.parentElement
          if (grandParent) {
            const grandParentRect = grandParent.getBoundingClientRect()
            console.log('Grand parent container rect:', grandParentRect)
          }
        }
        
        if (retryCount < maxRetries) {
          setTimeout(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          }, 100 * (retryCount + 1))
        } else {
          console.error('Failed to initialize map: container size remains invalid after', maxRetries, 'retries')
        }
        return
      }

      console.log('Initializing map with valid container size:', rect.width, 'x', rect.height)

      const warningMapZoom = Math.max(Number(this.setting.map_show || 0), 11)
      const maxZoom = Math.max(warningMapZoom + 4, 15)
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
        this.map = null
      }

      const mapOptions = {
        zoom: warningMapZoom,
        minZoom: 9,
        maxZoom: maxZoom,
        pitch: 12,
        center: center,
        mapStyleId: 'style3',
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }

      try {
        this.map = new TMap.Map(this.mapId, mapOptions)
        console.log('Map initialized successfully')
        
        this.fetchBoundaryData().then(geoJson => {
          console.log('fetchBoundaryData success:', geoJson)
          if (geoJson && geoJson.features && geoJson.features.length > 0) {
            // 转换 GeoJSON 格式为腾讯地图 MultiPolygon 格式
            this.boundaryGeometries = geoJson.features.map(feature => {
              // GeoJSON 的 coordinates 需要转换为腾讯地图的 paths 格式
              // GeoJSON Polygon: [[[lon, lat], [lon, lat], ...]]
              // 腾讯地图 Polygon: [new TMap.LatLng(lat, lon), new TMap.LatLng(lat, lon), ...]
              const coordinates = feature.geometry.coordinates
              let paths = []

              if (feature.geometry.type === 'Polygon') {
                // Polygon 格式: [[[lon, lat], [lon, lat], ...]]
                paths = coordinates[0].map(coord => new TMap.LatLng(coord[1], coord[0]))
              } else if (feature.geometry.type === 'MultiPolygon') {
                // MultiPolygon 格式: [[[[lon, lat], [lon, lat], ...]], ...]
                paths = coordinates[0][0].map(coord => new TMap.LatLng(coord[1], coord[0]))
              }

              return {
                id: feature.properties.name,
                paths: paths,
                styleId: 'boundary'
              }
            })
            this.calculateBoundaryBounds()
            this.renderBoundaryLayer()
            // 渲染视频点位标记
            this.renderVideoPoints()
          } else {
            console.log('No boundary data, rendering video points directly')
            this.renderVideoPoints()
          }
        }).catch((error) => {
          console.error('fetchBoundaryData failed:', error)
          console.log('Rendering video points without boundary data')
          this.renderVideoPoints()
        })
      } catch (error) {
        console.error('Failed to initialize map:', error)
      }
    },
    renderVideoPoints() {
      console.log('renderVideoPoints called, map:', this.map)
      if (!this.map) {
        console.log('Map is null, returning')
        return
      }

      // 清除旧的标记
      if (this.markerLayer && this.markerLayer.setMap) {
        this.markerLayer.setMap(null)
        this.markerLayer = null
      }

      // 在婺源中心点附近生成视频点位
      const baseLat = WUYUAN_CENTER.lat
      const baseLng = WUYUAN_CENTER.lng
      const offsetRange = 0.05 // 经纬度偏移范围

      // 模拟视频点位数据（实际应从API获取）
      const videoPointsData = [
        { id: 1, name: '大门入口', lat: baseLat + 0.01, lng: baseLng + 0.01, status: 'online', region: '区域A', type: '入口', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv' },
        { id: 2, name: '停车场A', lat: baseLat + 0.02, lng: baseLng - 0.015, status: 'offline', region: '区域A', type: '停车场', url: '' },
        { id: 3, name: '主干道', lat: baseLat - 0.015, lng: baseLng - 0.02, status: 'error', region: '区域B', type: '道路', url: '' },
        { id: 4, name: '中心广场', lat: baseLat + 0.025, lng: baseLng + 0.02, status: 'online', region: '区域B', type: '广场', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv' },
        { id: 5, name: '餐厅入口', lat: baseLat - 0.02, lng: baseLng + 0.015, status: 'online', region: '区域B', type: '入口', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv' },
        { id: 6, name: '儿童游乐区', lat: baseLat + 0.03, lng: baseLng - 0.01, status: 'offline', region: '区域C', type: '游乐设施', url: '' },
        { id: 7, name: '主干道', lat: baseLat - 0.025, lng: baseLng - 0.015, status: 'error', region: '区域C', type: '道路', url: '' },
        { id: 8, name: '观景台', lat: baseLat + 0.015, lng: baseLng + 0.025, status: 'online', region: '区域A', type: '景点', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv' },
        { id: 9, name: '停车场B', lat: baseLat - 0.01, lng: baseLng + 0.03, status: 'offline', region: '区域C', type: '停车场', url: '' },
        { id: 10, name: '洗手间', lat: baseLat + 0.005, lng: baseLng - 0.025, status: 'error', region: '区域A', type: '设施', url: '' },
        { id: 11, name: '洗手间', lat: baseLat - 0.03, lng: baseLng + 0.005, status: 'online', region: '区域B', type: '设施', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv' },
        { id: 12, name: '出口通道', lat: baseLat + 0.018, lng: baseLng - 0.008, status: 'online', region: '区域C', type: '出口', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv' },
        { id: 13, name: '停车场C', lat: baseLat - 0.008, lng: baseLng - 0.03, status: 'offline', region: '区域A', type: '停车场', url: '' },
        { id: 14, name: '商业区', lat: baseLat + 0.022, lng: baseLng - 0.022, status: 'online', region: '区域B', type: '商业', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv' },
        { id: 15, name: '主干道', lat: baseLat - 0.018, lng: baseLng + 0.022, status: 'error', region: '区域C', type: '道路', url: '' },
        { id: 16, name: '入口广场', lat: baseLat + 0.008, lng: baseLng + 0.018, status: 'online', region: '区域A', type: '广场', url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv' }
      ]

      this.videoPoints = videoPointsData

      // 创建图标样式
      const iconStyles = {
        online: new TMap.MarkerStyle({
          width: 32,
          height: 32,
          src: this.statusIcons.online,
          anchor: { x: 16, y: 16 }
        }),
        offline: new TMap.MarkerStyle({
          width: 32,
          height: 32,
          src: this.statusIcons.offline,
          anchor: { x: 16, y: 16 }
        }),
        error: new TMap.MarkerStyle({
          width: 32,
          height: 32,
          src: this.statusIcons.error,
          anchor: { x: 16, y: 16 }
        })
      }

      // 创建标记几何数据
      const geometries = videoPointsData.map(point => {
        return {
          id: point.id.toString(),
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: point.status,
          properties: {
            name: point.name,
            status: point.status,
            url: point.url,
            region: point.region,
            type: point.type
          }
        }
      })

      // 创建标记层
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: iconStyles,
        geometries: geometries
      })
      console.log('Marker layer created:', this.markerLayer)

      // 创建文字标签
      // 创建文本标注
      this.createTextLabels(videoPointsData)

      // 添加点击事件
      const that = this
      // 使用腾讯地图的正确事件绑定方式
      this.markerLayer.on('click', function(event) {
        console.log('Marker layer click event:', event)
        console.log('Event keys:', Object.keys(event))
        console.log('Event detail:', event.detail)

        // 尝试多种方式获取 geometry
        let geometry = null
        if (event.detail && event.detail.geometry) {
          geometry = event.detail.geometry
        } else if (event.geometry) {
          geometry = event.geometry
        } else if (event.detail && event.detail.marker) {
          geometry = event.detail.marker
        }

        console.log('Geometry:', geometry)

        if (geometry) {
          console.log('Geometry keys:', Object.keys(geometry))
          console.log('Geometry id:', geometry.id)
          console.log('Geometry properties:', geometry.properties)

          if (geometry.properties) {
            const pointId = parseInt(geometry.id)
            console.log('Point ID:', pointId, 'Properties:', geometry.properties)
            console.log('Calling playVideoFromPoint with ID:', pointId)
            that.playVideoFromPoint(pointId, geometry.properties)
          } else {
            console.log('No properties found in geometry')
          }
        } else {
          console.log('No geometry found in event')
        }
      })

      // 同时添加地图点击事件作为备用
      this.map.on('click', function(event) {
        console.log('Map click event:', event)
      })
    },
    // 创建文本标注
    createTextLabels(pointsData) {
      // 如果已存在标注层，先销毁
      if (this.textLayer) {
        this.textLayer.setMap(null)
        this.textLayer = null
      }

      const statusColors = {
        online: '#52c41a',
        offline: '#8c8c8c',
        error: '#ff4d4f'
      }

      const textGeometries = []
      pointsData.forEach(point => {
        // 只显示名称标签，状态通过图标颜色区分
        textGeometries.push({
          id: 'name_' + point.id,
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: 'nameStyle',
          content: point.name
        })
      })

      this.textLayer = new TMap.MultiLabel({
        map: this.map,
        styles: {
          nameStyle: new TMap.LabelStyle({
            fontSize: 11,
            color: '#ffffff',
            offset: { x: 0, y: 22 },
            whiteSpace: 'nowrap',
            strokeColor: 'rgba(0,0,0,0.5)',
            strokeWidth: 3
          })
        },
        geometries: textGeometries
      })
    },
    // 从点位播放视频
    playVideoFromPoint(pointId, properties) {
      const statusMap = {
        online: '在线',
        offline: '已离线',
        error: '异常'
      }

      // 设置当前播放的点位信息
      this.currentPlayPoint = {
        id: pointId,
        name: properties.name,
        status: properties.status,
        region: properties.region,
        type: properties.type,
        statusText: statusMap[properties.status] || '未知'
      }

      // 如果是在线状态，随机选择一个 FLV 视频流
      if (properties.status === 'online') {
        // 获取所有在线点位的视频流 URL
        const onlinePoints = this.videoPoints.filter(p => p.status === 'online' && p.url)
        if (onlinePoints.length > 0) {
          // 随机选择一个视频流
          const randomIndex = Math.floor(Math.random() * onlinePoints.length)
          this.currentPlayPoint.url = onlinePoints[randomIndex].url
        }
      }

      // 打开视频播放弹窗
      this.isPointVideoModalOpen = true

      console.log(`正在播放：${properties.name}`)
    },
    changeTheDate(day) {
      if (day === 0) {
        const query = {
          id: this.scenic_id,
          token: store.state.token
        }
        this.$router.push({ path: '/scenic_warning', query: query })
        this.$router.go(0)
        return
      }

      const today = this.req_date ? new Date(this.req_date) : new Date()
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetdayMilliseconds)
      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleDate(tDate)
      const changeDate = tYear + '-' + tMonth + '-' + tDate
      const query = {
        id: this.scenic_id,
        date: changeDate,
        token: store.state.token
      }
      this.$router.push({ path: '/scenic_warning', query: query })
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
.page-container {
  width: 100vw;
  height: calc(100vh - 54px);
  font-family: PingFang SC;
  user-select: none;
}

.data-box {
  background-color: rgba(3, 10, 69, 0.92);
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png), url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.head {
  position: relative;
  height: 80px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

.head-title {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.head-type {
  width: 520px;
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;
}

.type-item2 {
  color: #fff;
}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
}

.warning-main {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 500px;
  background: rgba(6, 14, 96, 0.6);
  overflow: hidden;
}

.migrateMap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-width: 500px;
  min-height: 500px;
  background-color: #0a1628;
  z-index: 0;
}

/* 监控点位统计 */
.video-points-stats {
  display: flex;
  justify-content: space-around;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: rgba(3, 10, 69, 0.8);
  border-radius: 6px;
  border: 1px solid rgba(80, 220, 255, 0.2);
}

.stats-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stats-icon {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.online-icon {
  background: #52c41a;
  box-shadow: 0 0 8px rgba(82, 196, 26, 0.6);
}

.offline-icon {
  background: #8c8c8c;
  box-shadow: 0 0 8px rgba(140, 140, 140, 0.6);
}

.error-icon {
  background: #ff4d4f;
  box-shadow: 0 0 8px rgba(255, 77, 79, 0.6);
}

.total-icon {
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  box-shadow: 0 0 8px rgba(76, 217, 255, 0.6);
}

.stats-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}

.stats-count {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  min-width: 28px;
}

/* 视频监控 */
.video-stream-section {
  margin-top: 16px;
  padding: 12px;
  background: rgba(3, 10, 69, 0.92);
  border-radius: 8px;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.video-stream-list {
  margin-top: 10px;
}

.video-stream-item {
  margin-bottom: 16px;
}

.video-stream-item:last-child {
  margin-bottom: 0;
}

.stream-title {
  padding: 8px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}

.stream-body {
  padding: 0 10px 10px;
  box-sizing: border-box;
  width: 100%;
}

.stream-video {
  display: block;
  width: 100%;
  height: 200px;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: contain;
  background-color: #000;
  border-radius: 4px;
}

.warning-left {
  float: left;
  margin: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
  height: calc(100% - 32px);
}

.warning-right {
  position: fixed;
  right: 16px;
  top: 96px;
  z-index: 100;
  max-width: 90vh;
  max-height: 90vh;
}

.warning-right.collapsed {
  max-width: 200px;
  max-height: 40px;
}

.monitor-toggle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  color: #fff;
}

.monitor-toggle-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.monitor-toggle-header .monitor-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0;
}

.toggle-icon {
  font-size: 12px;
  color: #4cd9ff;
}

.monitor-content {
  margin-top: 0;
  padding: 0;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
}

.monitor-content.show {
  margin-top: 8px;
  max-height: 60vh;
  opacity: 1;
}

.screen-grid-item {
  cursor: grab;
}

.screen-grid-item:hover {
}

.screen-grid-item.dragging {
  cursor: grabbing;
  opacity: 0.6;
}

.screen-grid-item.drag-over {
  border: 2px dashed #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.drag-handle {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.screen-video-wrapper:hover .drag-handle {
  opacity: 1;
}

.drag-icon {
  color: #fff;
  font-size: 10px;
  line-height: 1;
}

/* 运维看板按钮 */
.maintenance-section {
  margin-top: 16px;
}

.maintenance-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: rgba(76, 217, 255, 0.1);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 4px;
  color: #4cd9ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.maintenance-btn:hover {
  background: rgba(76, 217, 255, 0.2);
  border-color: rgba(80, 220, 255, 0.5);
}

.maintenance-btn.active {
  background: rgba(76, 217, 255, 0.25);
  border-color: #4cd9ff;
}

.maintenance-icon {
  font-size: 16px;
}

.maintenance-badge {
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* 运维看板面板 */
.maintenance-panel {
  position: absolute;
  left: 430px;
  top: 16px;
  width: 380px;
  height: calc(100% - 32px);
  z-index: 150;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-20px);
  transition: all 0.3s ease-out;
}

.maintenance-panel.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.maintenance-content {
  height: 100%;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.maintenance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(80, 220, 255, 0.2);
}

.maintenance-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.maintenance-close {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #8cefff;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.maintenance-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 通道列表 */
.channel-list {
  padding: 8px;
  overflow-y: auto;
  max-height: calc(70vh - 60px);
}

.channel-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 4px;
  border-left: 3px solid transparent;
  transition: all 0.2s ease;
}

.channel-item.status-normal {
  border-left-color: #52c41a;
}

.channel-item.status-abnormal {
  border-left-color: #ff4d4f;
  background: rgba(255, 77, 79, 0.08);
  animation: pulse-abnormal 2s infinite;
}

.channel-item.status-offline {
  border-left-color: #d9d9d9;
  opacity: 0.7;
}

@keyframes pulse-abnormal {
  0%, 100% {
    background: rgba(255, 77, 79, 0.08);
  }
  50% {
    background: rgba(255, 77, 79, 0.15);
  }
}

.channel-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.channel-item.status-normal .channel-status-dot {
  background: #52c41a;
  box-shadow: 0 0 6px #52c41a;
}

.channel-item.status-abnormal .channel-status-dot {
  background: #ff4d4f;
  box-shadow: 0 0 6px #ff4d4f;
  animation: blink 1s infinite;
}

.channel-item.status-offline .channel-status-dot {
  background: #d9d9d9;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.channel-info {
  flex: 1;
  min-width: 0;
}

.channel-name {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 2px;
}

.channel-device {
  font-size: 11px;
  color: #8cefff;
}

.channel-status {
  margin: 0 10px;
}

.channel-status span {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}

.channel-status .status-normal {
  background: rgba(82, 196, 26, 0.15);
  color: #52c41a;
}

.channel-status .status-abnormal {
  background: rgba(255, 77, 79, 0.15);
  color: #ff4d4f;
}

.channel-status .status-offline {
  background: rgba(217, 217, 217, 0.15);
  color: #d9d9d9;
}

.channel-time {
  text-align: right;
}

.time-label {
  font-size: 11px;
  color: #888;
}

.time-value {
  display: block;
  font-size: 11px;
  color: #fff;
  margin-top: 2px;
}

.warning-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 20px 18px 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.warning-panel-large {
  height: calc(100% - 250px);
  min-height: 640px;
}

.warning-panel-small {
  margin-top: 14px;
  height: 236px;
}

.sentiment-panel {
  flex: 1;
  min-height: 0;
  margin-bottom: 14px;
}

.sentiment-panel:last-child {
  margin-bottom: 0;
}

.sentiment-chart {
  width: 100%;
  height: calc(100% - 30px);
  min-height: 120px;
}

.sentiment-keywords {
  margin-top: 12px;
}

.sentiment-keywords-title {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 10px;
  font-weight: 600;
}

.sentiment-keywords-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.sentiment-keyword-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
}

.keyword-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.86);
}

.keyword-count {
  font-size: 12px;
  color: #fff;
  font-weight: 600;
}

.keyword-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keyword-edit-btn {
  background: linear-gradient(135deg, #6fb8ff 0%, #00d4aa 100%);
  border: none;
  color: #141439;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 16px;
  border-radius: 12px;
  cursor: pointer;
}

.keyword-table-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 12px;
  padding-right: 4px;
}

.keyword-table-container::-webkit-scrollbar {
  width: 4px;
}

.keyword-table-container::-webkit-scrollbar-track {
  background: transparent;
}

.keyword-table-container::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.keyword-table {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.keyword-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
  position: relative;
}

.keyword-row.keyword-disabled {
  opacity: 0.5;
}

.keyword-tag {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 4px;
}

.keyword-value {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

.keyword-switch {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}

.switch-track {
  display: inline-block;
  width: 28px;
  height: 16px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  position: relative;
  transition: background 0.3s;
  cursor: pointer;
}

.switch-track.switch-on {
  background: #4cd9ff;
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.3s;
}

.switch-thumb.switch-thumb-on {
  left: 14px;
}



.warning-panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 18px;
}

.warning-right .warning-panel-title {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.warning-panel-full {
  height: calc(100% - 20px);
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.supervision-warning-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.supervision-warning-list::-webkit-scrollbar {
  width: 4px;
}

.supervision-warning-list::-webkit-scrollbar-track {
  background: transparent;
}

.supervision-warning-list::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.supervision-warning-item {
  padding: 12px;
  margin-bottom: 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 6px;
  border-left: 3px solid #5589F2;
}

.supervision-warning-item.negative-warning {
  border-left: 3px solid #E53F31;
  background: rgba(229, 63, 49, 0.15);
}

.supervision-warning-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.warning-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.warning-status {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.status-待受理 {
  background: rgba(255, 165, 0, 0.2);
  color: #FFA500;
}

.status-处理中 {
  background: rgba(85, 137, 242, 0.2);
  color: #5589F2;
}

.status-已办结 {
  background: rgba(0, 212, 170, 0.2);
  color: #00D4AA;
}

.supervision-warning-content {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 6px;
}

.supervision-warning-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.warning-type {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.warning-type.negative-type {
  background: rgba(229, 63, 49, 0.2);
  color: #E53F31;
}

.warning-party {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.warning-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.generate-workorder-btn {
  padding: 6px 12px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.generate-workorder-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.export-button-container {
  margin-top: 16px;
  flex-shrink: 0;
}

.export-button {
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #5589F2 0%, #3F66FF 100%);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-button:hover {
  background: linear-gradient(135deg, #6699FF 0%, #5575FF 100%);
}

.keyword-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.keyword-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  max-height: 80vh;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1001;
}

.keyword-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-modal-body {
  height: 300px;
  display: flex;
  flex-direction: column;
}

.keyword-modal-table-header {
  display: flex;
  padding: 12px 16px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px 4px 0 0;
}

.keyword-modal-table-scroll {
  flex: 1;
  overflow-y: auto;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.keyword-modal-table-header span {
  flex: 1;
  text-align: center;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

.keyword-modal-table-header span:last-child {
  flex: 0.8;
}

.keyword-modal-table-body {
  padding: 0;
}

.keyword-modal-table-row {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
  align-items: center;
  justify-content: center;
  background: rgba(11, 27, 88, 0.52);
}

.keyword-modal-table-row.keyword-disabled {
  opacity: 0.5;
}

.keyword-modal-table-row:last-child {
  border-bottom: none;
}

.keyword-modal-table-row > span {
  flex: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.keyword-modal-table-row > span:last-child {
  flex: 0.8;
}

.keyword-modal-table-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.keyword-modal-table-actions a {
  color: #4cd9ff;
  text-decoration: none;
  font-size: 13px;
}

.keyword-modal-table-actions a:hover {
  text-decoration: underline;
}

.keyword-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.keyword-modal-add-btn {
  padding: 10px 40px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-modal-add-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.export-modal {
  position: fixed;
  inset: 0;
  z-index: 1004;
}

.export-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.export-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 480px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.export-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.export-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.export-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.export-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.export-modal-body {
  padding: 8px 0;
}

.export-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.export-form-item:last-child {
  margin-bottom: 0;
}

.export-form-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 80px;
  flex-shrink: 0;
}

.export-date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-date-input {
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  outline: none;
}

.export-date-input:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-date-input:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.date-separator {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.export-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.export-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.export-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.export-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.export-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.tip-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.tip-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.tip-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.tip-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.tip-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.tip-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.tip-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tip-modal-body {
  padding: 8px 0;
}

.tip-modal-message {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.tip-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.tip-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.tip-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.confirm-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.confirm-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.confirm-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.confirm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.confirm-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.confirm-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.confirm-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.confirm-modal-body {
  padding: 8px 0;
}

.confirm-modal-info {
  background: rgba(11, 27, 88, 0.52);
  border-radius: 6px;
  padding: 16px;
}

.confirm-info-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.confirm-info-item:last-child {
  margin-bottom: 0;
}

.confirm-info-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 70px;
  flex-shrink: 0;
}

.confirm-info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  flex: 1;
  word-break: break-all;
}

.confirm-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.confirm-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.confirm-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.confirm-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.confirm-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.confirm-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.keyword-edit-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.keyword-edit-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-edit-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1003;
}

.keyword-edit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-edit-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-edit-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-edit-modal-body {
  padding: 0;
}

.keyword-edit-form-item {
  margin-bottom: 16px;
}

.keyword-edit-form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
  font-weight: 500;
}

.keyword-edit-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  background: rgba(11, 27, 88, 0.52);
  color: rgba(255, 255, 255, 0.86);
}

.keyword-edit-input:focus {
  outline: none;
  border-color: #4cd9ff;
}

.keyword-edit-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.keyword-edit-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-edit-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-edit-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-batch-import-modal {
  position: fixed;
  inset: 0;
  z-index: 1003;
}

.keyword-batch-import-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
}

.keyword-batch-import-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.keyword-batch-import-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.keyword-batch-import-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-batch-import-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-batch-import-modal-close:hover {
  color: #fff;
}

.keyword-batch-import-modal-body {
  padding: 0;
}

.batch-import-tip {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 12px;
}

.batch-import-textarea {
  width: 100%;
  height: 200px;
  padding: 12px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
}

.batch-import-textarea::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.keyword-batch-import-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-batch-import-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-batch-import-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-modal-import-btn {
  padding: 6px 16px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  margin-right: 12px;
}

.keyword-modal-import-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.warning-record {
  position: absolute;
  top: 28px;
  left: 486px;
  z-index: 3;
  width: 236px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: rgba(11, 24, 112, 0.88);
  border: 1px solid rgba(82, 150, 255, 0.3);
}

.warning-record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.sentiment-detail-panel {
  position: fixed;
  top: 110px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1004;
  width: 80%;
  max-width: 1000px;
  max-height: 70vh;
}

.sentiment-detail-panel-dialog {
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.sentiment-detail-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.sentiment-detail-panel-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.sentiment-detail-panel-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.sentiment-detail-panel-body {
  padding: 16px;
  background: rgba(11, 27, 88, 0.52);
  border-radius: 4px;
  max-height: calc(70vh - 80px);
  overflow-y: auto;
}

.sentiment-detail-header {
  text-align: center;
  margin-bottom: 16px;
}

.sentiment-detail-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.sentiment-detail-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.info-item {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
}

.info-label {
  color: rgba(255, 255, 255, 0.5);
  margin-right: 4px;
}

.sentiment-detail-url {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.url-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-right: 8px;
}

.url-link {
  font-size: 14px;
  color: #4cd9ff;
  text-decoration: none;
  word-break: break-all;
}

.url-link:hover {
  text-decoration: underline;
}

.sentiment-detail-content {
  margin-top: 16px;
}

.content-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}

.content-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.8;
  padding: 12px;
  background: rgba(3, 10, 69, 0.92);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  min-height: 200px;
}

.supervision-warning-item {
  cursor: pointer;
  transition: all 0.3s;
}

.supervision-warning-item:hover {
  background: rgba(65, 100, 200, 0.45);
}

.monitor-panel {
  padding: 20px 18px 16px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.monitor-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-text {
  flex: 1;
}

.maintenance-btn-mini {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: rgba(0, 212, 255, 0.15);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.maintenance-btn-mini:hover {
  background: rgba(0, 212, 255, 0.25);
  border-color: rgba(0, 212, 255, 0.5);
}

.maintenance-btn-mini.active {
  background: rgba(0, 212, 255, 0.3);
  border-color: rgba(0, 212, 255, 0.6);
}

.mini-icon {
  font-size: 14px;
}

.mini-badge {
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  background: #ff6b6b;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 9px;
  text-align: center;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #8cefff;
  margin-bottom: 12px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-row {
  display: flex;
  gap: 12px;
}

.filter-item {
  flex: 1;
}

.filter-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 6px;
  display: block;
}

.filter-select-box {
  position: relative;
}

.filter-select {
  width: 100%;
  padding: 8px 32px 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  cursor: pointer;
  outline: none;
  appearance: none;
}

.filter-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.select-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  pointer-events: none;
}

.screen-section {
  margin-bottom: 20px;
}

.screen-buttons {
  display: flex;
  gap: 8px;
}

.screen-btn {
  flex: 1;
  padding: 8px 0;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.screen-btn:hover {
  border-color: #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.screen-btn.active {
  background: linear-gradient(135deg, #6fb8ff 0%, #00d4aa 100%);
  border-color: transparent;
  color: #141439;
  font-weight: 600;
}

.timeline-section {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.timeline-list {
  height: calc(100% - 28px);
  overflow-y: auto;
}

.timeline-list::-webkit-scrollbar {
  width: 4px;
}

.timeline-list::-webkit-scrollbar-track {
  background: transparent;
}

.timeline-list::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.timeline-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(76, 165, 255, 0.1);
}

.timeline-item:last-child {
  border-bottom: none;
}

.timeline-time {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  width: 80px;
  flex-shrink: 0;
}

.timeline-dot {
  width: 8px;
  height: 8px;
  background: #4cd9ff;
  border-radius: 50%;
  margin: 0 10px;
  flex-shrink: 0;
}

.timeline-content {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

.timeline-item:hover {
  background-color: rgba(76, 165, 255, 0.1);
}

/* 事件类型标记 */
.timeline-dot.dot-congestion {
  background: #ff6b6b;
  box-shadow: 0 0 6px rgba(255, 107, 107, 0.6);
}

.timeline-dot.dot-fault {
  background: #ffa502;
  box-shadow: 0 0 6px rgba(255, 165, 2, 0.6);
}

.timeline-dot.dot-normal {
  background: #4cd9ff;
}

/* 视频回放弹窗 */
.video-playback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-content {
  position: relative;
  width: 80%;
  max-width: 900px;
  background: rgba(3, 10, 69, 0.95);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(78, 240, 228, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(80, 220, 255, 0.2);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body {
  padding: 20px;
}

.playback-info {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  width: 100px;
}

.info-value {
  font-size: 13px;
  color: #fff;
}

.info-value.type-congestion {
  color: #ff6b6b;
}

.info-value.type-fault {
  color: #ffa502;
}

.video-container {
  margin-bottom: 20px;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
}

.offline-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  background: #1a1a1a;
}

.offline-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.offline-icon {
  font-size: 60px;
}

.offline-text {
  font-size: 18px;
  color: #ff4d4f;
  font-weight: bold;
}

.playback-video {
  width: 100%;
  height: 400px;
  object-fit: contain;
}

/* 点位视频播放弹窗 */
.point-video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.point-video-modal .modal-content.video-modal {
  max-width: 1000px;
}

.point-video-player {
  width: 100%;
  height: 500px;
  object-fit: contain;
}

.video-info {
  margin-top: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.video-info .info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.video-info .info-row:last-child {
  margin-bottom: 0;
}

.video-info .info-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  width: 60px;
}

.video-info .info-value {
  color: #fff;
  font-size: 14px;
}

.video-info .status-online {
  color: #52c41a;
}

.video-info .status-offline {
  color: #ff4d4f;
}

.modal-icon {
  margin-right: 8px;
}

.export-section {
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.export-title {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 15px;
}

.time-range-selector {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.range-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.time-input {
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(80, 220, 255, 0.3);
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
}

.export-btn {
  padding: 8px 20px;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
}

.export-btn:hover {
  background: linear-gradient(135deg, #00e5ff, #00a8dd);
  transform: translateY(-1px);
}

.screen-preview-panel {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.screen-grid {
  flex: 1;
  display: grid;
  padding: 12px 0;
  overflow-y: auto;
}

.screen-grid::-webkit-scrollbar {
  width: 4px;
}

.screen-grid::-webkit-scrollbar-track {
  background: transparent;
}

.screen-grid::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.screen-grid-item {
  aspect-ratio: 16 / 9;
  background: rgba(45, 72, 180, 0.4);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  box-shadow: inset 0 0 10px rgba(76, 217, 255, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.screen-video-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.screen-video-title {
  padding: 4px 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.screen-video-body {
  flex: 1;
  padding: 4px;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 0;
}

.screen-video {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  object-fit: contain;
  background-color: #000;
  border-radius: 2px;
}

.screen-info {
  text-align: center;
  padding-top: 12px;
  font-size: 14px;
  color: #8cefff;
  font-weight: 600;
  border-top: 1px solid rgba(76, 165, 255, 0.2);
}
</style>




// WEBPACK FOOTER //
// src/pages/video-surveillance.vue